import { useMutation } from 'react-query';
import Empresas from '../../services/Empresas';
import AttToken from '../../services/AttToken';
import { toast, ToastContainer } from 'react-toastify';
import queryClient from '../../services/query';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useMask } from '@react-input/mask';
import CloseIcon from '@mui/icons-material/Close';
import { empresaType } from '../../context/EmpresasContext';

type modalEditProps = {
  openModal: boolean,
  setOpenModal: Function,
  selectedEmpresa: empresaType,
  setSelectedEmpresa: Function,
}

const empresaService = new Empresas();

export default function ModalEditarEmpresa({ openModal, setOpenModal, selectedEmpresa, setSelectedEmpresa }: modalEditProps) {
  const inputRef = useMask({ mask: '__.___.___/____-__', replacement: '_' });

  function checkChar(value: string): undefined | string {
    if (value === '') {
      return ''
    }
    const pattern = /^[A-Za-z]+$/;
    if (pattern.test(value)) {
      return value;
    }
    return
  }

  const { mutate, isLoading } = useMutation({
    mutationKey: ['PUT_EMPRESA'],
    mutationFn: async () => {
      const promise = toast.promise(async () => {
        const token = await AttToken();
        if (!token) throw new Error('Token não encontrado');
        if (token) {
          const empresa = {
            id: selectedEmpresa.id as string,
            nome: selectedEmpresa.nome,
            cnpj: selectedEmpresa.cnpj,
            emailNotificacao: selectedEmpresa.emailNotificacao,
            selectExecutionsLimit: selectedEmpresa.selectExecutionsLimit,
            status: selectedEmpresa?.status?.toLowerCase(),
          }
          const response = await empresaService.editaEmpresa(token, empresa)
          if (!response) throw new Error('Erro ao editar empresa');
          return response
        }
      }, {
        pending: 'Editando empresa...',
        success: 'Empresa editada!',
        error: 'Erro ao editar empresa'
      }, { toastId: 'editEmpresa' });
      return await promise
    },
    onSuccess: () => {
      setSelectedEmpresa(null)
      queryClient.resetQueries(['GET_EMPRESAS'])
      setOpenModal(!openModal)
    },
  })

  function editaCampos(campo: string, value: string | number) {
    setSelectedEmpresa((prev: empresaType) => ({ ...prev, [campo]: value }))
  }

  return (
    <>
      <ToastContainer />
      <Dialog
        onClose={() => setOpenModal(!openModal)}
        aria-labelledby="customized-dialog-title"
        open={openModal}
      >
        <DialogTitle sx={{ m: 0, p: 2, width: '500px' }} id="customized-dialog-title">
          Adicionar domínio
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setOpenModal(!openModal)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Stack direction='column' spacing={2} alignItems='baseline' justifyContent='flex-start' padding={2}>
            <TextField
              fullWidth
              label='Nome'
              value={selectedEmpresa?.nome}
              onChange={(event) => editaCampos('nome', event.target.value)}
            />
            <TextField
              fullWidth
              label='CNPJ'
              inputRef={inputRef}
              value={selectedEmpresa?.cnpj}
              onChange={(event) => editaCampos('cnpj', event.target.value)}
            />
            <TextField
              disabled
              fullWidth
              label='Domínio'
              value={selectedEmpresa?.dominio}
              onChange={(event) => {
                const domValue = checkChar(event.target.value)
                if (domValue === undefined) return;

                editaCampos('dominio', domValue)
              }}
            />
            <TextField
              fullWidth
              label='E-mail de notificação e pesquisa'
              value={selectedEmpresa?.emailNotificacao ? String(selectedEmpresa?.emailNotificacao) : ''}
              onChange={(event) => editaCampos('emailNotificacao', event.target.value)}
            />
            <TextField
              fullWidth
              value={selectedEmpresa?.selectExecutionsLimit ? String(selectedEmpresa?.selectExecutionsLimit) : ''}
              onChange={(event) => editaCampos('selectExecutionsLimit', parseInt(event.target.value))}
              label='Máximo de execuções selecionadas'
              type='text'
            />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedEmpresa.status}
                label="Status"
                onChange={(event) => editaCampos('status', event.target.value)}
              >
                <MenuItem value={('ativo').toLowerCase()}>Ativo</MenuItem>
                <MenuItem value={('inativo').toLowerCase()}>Inativo</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => mutate()} disabled={isLoading}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}